// Map action types
export const FETCH_NEARBY_PINS_REQUEST = 'map/FETCH_NEARBY_PINS_REQUEST';
export const FETCH_NEARBY_PINS_SUCCESS = 'map/FETCH_NEARBY_PINS_SUCCESS';
export const FETCH_NEARBY_PINS_FAILURE = 'map/FETCH_NEARBY_PINS_FAILURE';

export const FETCH_TOUR_MAP_REQUEST = 'map/FETCH_TOUR_MAP_REQUEST';
export const FETCH_TOUR_MAP_SUCCESS = 'map/FETCH_TOUR_MAP_SUCCESS';
export const FETCH_TOUR_MAP_FAILURE = 'map/FETCH_TOUR_MAP_FAILURE';

export const SET_USER_LOCATION = 'map/SET_USER_LOCATION';
export const SET_MAP_CENTER = 'map/SET_MAP_CENTER';
export const SET_MAP_ZOOM = 'map/SET_MAP_ZOOM';
export const SELECT_PIN = 'map/SELECT_PIN';
export const CLEAR_SELECTED_PIN = 'map/CLEAR_SELECTED_PIN';
